import { FormGroup } from "@angular/forms";

export class FormHelper {
  public static markAllControlsAsDirtyAndTouchedIfInvalid(form: FormGroup) {
    if(form?.controls === undefined || form.valid) return;

    this.markAllControlsAsDirtyAndTouched(form);
  }

  public static markAllControlsAsDirtyAndTouched(form: FormGroup) {
    if (form && form.controls) {
      Object.keys(form.controls).forEach(key => {
        form.controls[key].markAsDirty();
        form.controls[key].markAsTouched();
      });
    }
  }
}
